export default { sha: '612b763e953e417bd12d843187e1b4620ac5a391', buildNumber: 'undefined' }
